import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import gibletLogo from '@/assets/giblet-logo.png';

const functionalAreas = [
  { id: 'digital-twin', name: 'Digital Twin Integration', description: 'AI-driven safety and logistics simulation' },
  { id: 'ehss', name: 'EHSS Planning', description: 'Safety protocols and workforce planning' },
  { id: 'smart-logistics', name: 'Smart Logistics', description: 'Transportation and supply chain optimization' },
  { id: 'modularization', name: 'Modularization Standards', description: 'Module design and fabrication best practices' },
  { id: 'awp', name: 'Advanced Work Packaging', description: 'AWP implementation and digital workflows' },
];

export default function DemoCallForKnowledgeFunctionalArea() {
  const navigate = useNavigate();
  const [selectedArea, setSelectedArea] = useState('');

  const handleNext = () => {
    if (selectedArea) {
      navigate('/demo-call-for-knowledge/connection', {
        state: { functionalArea: selectedArea }
      });
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-3xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <img src={gibletLogo} alt="Giblet Logo" className="h-16 w-auto" />
        </div>

        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold text-foreground">Select Functional Area</h1>
          <p className="text-lg text-muted-foreground">
            Choose the area where you need knowledge contributions
          </p>
        </div>

        <div className="bg-card rounded-lg p-8 shadow-lg space-y-6">
          <RadioGroup value={selectedArea} onValueChange={setSelectedArea}>
            {functionalAreas.map((area) => (
              <div key={area.id} className="flex items-start space-x-3 p-4 rounded-lg hover:bg-accent/50 transition-colors">
                <RadioGroupItem value={area.id} id={area.id} className="mt-1" />
                <Label htmlFor={area.id} className="flex-1 cursor-pointer">
                  <div className="font-semibold text-foreground">{area.name}</div>
                  <div className="text-sm text-muted-foreground mt-1">{area.description}</div>
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>

        <div className="flex justify-center gap-4">
          <Button
            variant="outline"
            onClick={() => navigate('/demo-call-for-knowledge')}
            className="min-w-[120px]"
          >
            Back
          </Button>
          <Button
            onClick={handleNext}
            disabled={!selectedArea}
            className="min-w-[120px]"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
